import * as React from "react";
import { getIn, useField, useFormikContext } from "formik";
import { cn } from "@/lib/utils";
import { Input as ShadcnInput } from "@/components/ui/input";

interface FormikInputProps extends React.ComponentProps<"input"> {
    name: string;
}

const FormikInput = React.forwardRef<HTMLInputElement, FormikInputProps>(
    ({ className, ...props }, ref) => {
        const [field] = useField(props.name);
        const { errors } = useFormikContext<{
            [key: string]: unknown;
        }>();

        const hasErrors = !!getIn(errors, props.name);

        return (
            <ShadcnInput
                className={cn(hasErrors ? "border-red-500" : "", className)}
                ref={ref}
                {...field}
                {...props}
            />
        );
    },
);

FormikInput.displayName = "FormikInput";

export { FormikInput };
